//菜单悬停和离开
document.addEventListener('DOMContentLoaded', function() {
    let item = document.querySelector("#Details-HeaderMenu-2");
    let subMenu = document.querySelector("#MegaMenu-Content-2");
  
    item.addEventListener("mouseover",function(){document.querySelector("#Details-HeaderMenu-2").setAttribute("open","")});
    item.addEventListener("mouseout",function(){
        // 延迟隐藏子菜单，以便鼠标悬停在子菜单上时不会立刻消失
        setTimeout(() => {
            // 判断鼠标是否离开了主菜单和子菜单
            if (!item.matches(':hover') && !subMenu.matches(':hover')) {
                document.querySelector("#Details-HeaderMenu-2").removeAttribute("open");
            }
        }, 200); // 延迟200ms
    });
  
    subMenu.addEventListener("mouseover",function(){item.setAttribute("open","")});
  
    subMenu.addEventListener("mouseout",function(){
        // 延迟隐藏子菜单，以便鼠标悬停在子菜单上时不会立刻消失
        setTimeout(() => {
            // 判断鼠标是否离开了主菜单和子菜单
            if (!item.matches(':hover') && !subMenu.matches(':hover')) {
                item.removeAttribute("open","")
            }
       }, 200); // 延迟200ms
    });
  
    item.addEventListener("click",function(){ window.location.href="/collections/all"});
});

document.addEventListener('DOMContentLoaded', function() {
    let item = document.querySelector("#Details-HeaderMenu-3");
    let subMenu = document.querySelector("#MegaMenu-Content-3");
  
    item.addEventListener("mouseover",function(){document.querySelector("#Details-HeaderMenu-3").setAttribute("open","")});
    item.addEventListener("mouseout",function(){
        // 延迟隐藏子菜单，以便鼠标悬停在子菜单上时不会立刻消失
        setTimeout(() => {
            // 判断鼠标是否离开了主菜单和子菜单
            if (!item.matches(':hover') && !subMenu.matches(':hover')) {
                document.querySelector("#Details-HeaderMenu-3").removeAttribute("open");
            }
        }, 200); // 延迟200ms
    });
  
    subMenu.addEventListener("mouseover",function(){item.setAttribute("open","")});
  
    subMenu.addEventListener("mouseout",function(){
        // 延迟隐藏子菜单，以便鼠标悬停在子菜单上时不会立刻消失
        setTimeout(() => {
            // 判断鼠标是否离开了主菜单和子菜单
            if (!item.matches(':hover') && !subMenu.matches(':hover')) {
                item.removeAttribute("open","")
            }
       }, 200); // 延迟200ms
    });
  
    item.addEventListener("click",function(){ window.location.href="/collections/all"});
});